<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500"
  >
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Access Denied
      </v-card-title>

      <v-card-text>
        <p>
          Access to ICT PLUS is by default open to all school principals and field operations staff.
        </p>
        <p>
          If you would like to access ICT PLUS for your school, please request access from your principal. Your
          principal can provide access via AMU, by selecting "ICP - ICT PLUS Delegation" in the applications list.
        </p>
        <p>
          If you are a relieving principal for a school whose principal is not available to delegate access, please log
          a ticket with ED Connect, who can resolve this for you.
        </p>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          flat
          @click="logout()"
          style="width: 120px; height: 50px; font-size: 16px; font-weight: bold;"
        >
          Log out
        </v-btn>
      </v-card-actions>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          flat
          @click="redirect()"
          style="width: 120px; height: 50px; font-size: 16px; font-weight: bold;"
        >
          Log in again
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: "AccessDeniedError",
    data() {
      return {dialog: true};
    },

    methods: {
      redirect() {
        window.location = '/auth/saml/redirect';
      },
      logout() {
        let ssoLogoutUrl = `https://ssoaddonsext.test.det.nsw.edu.au/ssoaddon/logout`;
        if(location.hostname.match('test.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://ssoaddonsext.test.det.nsw.edu.au/ssoaddon/logout`;
        } else if(location.hostname.match('pre.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://ssoaddonsext.pre.det.nsw.edu.au/ssoaddon/logout`;
          console.log(ssoLogoutUrl);
        } else if(location.hostname.match('ictplus.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://ssoaddonsext.det.nsw.edu.au/ssoaddon/logout`;
        }
        console.log(ssoLogoutUrl);
        //sessionStorage.removeItem('ictp-token');
        //sessionStorage.removeItem('ictp-splash-page-status');
        this.clearAllFilters();
        sessionStorage.clear();
        this.removeToken(this.$store.state);
        window.location = ssoLogoutUrl;
      },
      ...mapActions(['redirectIn','removeToken','clearAllFilters']),
    }
  }
</script>

<style scoped>

</style>
